import { SchemaFormFields } from '@mews-commander/form';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { WithEnterpriseId } from '@mews-commander/types';
import { OverlayedLoader } from '@mews-commander/ui';
import { createZodFormResolver, Form, getDefaults, lt } from '@mews/framework';
import { Button, Stack, Typography } from '@optimus-web/core';
import { useCancelReservations } from '../useCancelReservations';
import {
    cancelReservationsFormDefinition,
    CancelReservationsFormInputValues,
    cancelReservationsFormSchema,
    CancelReservationsFormValues,
} from './schema';

export const CancelReservationsForm = ({ enterpriseId }: WithEnterpriseId) => {
    const { name } = useEnterprise(enterpriseId);
    const { handleCancelReservations, isPending, isSuccess } = useCancelReservations({
        enterpriseId,
        enterpriseName: name,
    });

    return (
        <>
            {/* When success keep showing loader until user is redirected away upon closing of the toast message  */}
            <OverlayedLoader show={isPending || isSuccess} />
            <Stack vertical spacing="200">
                <Stack vertical spacing="200">
                    <Typography textStyle="titleMediumStrong" as="div">
                        {lt('CancelReservationsAll')}
                    </Typography>
                    <Typography textStyle="bodyLarge" as="div">
                        {lt('CancelReservationsAllWarning')}
                    </Typography>
                </Stack>
                <Form
                    onSubmit={(formData) => handleCancelReservations(formData.details)}
                    defaultValues={getDefaults(cancelReservationsFormSchema)}
                    resolver={createZodFormResolver<CancelReservationsFormValues, CancelReservationsFormInputValues>(
                        cancelReservationsFormSchema
                    )}
                >
                    <Stack vertical spacing="300">
                        <SchemaFormFields
                            schema={cancelReservationsFormSchema}
                            formDefinition={cancelReservationsFormDefinition}
                        />
                        <Stack alignment="end">
                            <Button variant="destructive" type="submit">
                                {lt('CancelReservationPlural')}
                            </Button>
                        </Stack>
                    </Stack>
                </Form>
            </Stack>
        </>
    );
};
